import { render, staticRenderFns } from "./WizardEnvironmentVolume.vue?vue&type=template&id=a408e0c8"
import script from "./WizardEnvironmentVolume.vue?vue&type=script&lang=js"
export * from "./WizardEnvironmentVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports